import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {VIEWER_END_STATE_NAME} from '../constant/viewerConstant';
import {ViewerEndState} from './ViewerEndState.intreface';
export const viewerEndSlice = createSlice({
  name: VIEWER_END_STATE_NAME,
  initialState: {
    myRating: {},
    isExposed: false,
  } as ViewerEndState,
  reducers: {
    setIsViewerEndExposed: (state, action: PayloadAction<boolean>) => {
      state.isExposed = action.payload;
    },
    setMyRating: (
      state,
      action: PayloadAction<{
        productId: number;
        myRating: number;
      }>
    ) => {
      state.myRating[action.payload.productId] = action.payload.myRating;
    },
  },
});

export const {setIsViewerEndExposed, setMyRating} = viewerEndSlice.actions;
